import { Box } from '@grupoboticario/flora-react'

import { PREVIEW_LABELS } from '@/constants/eventPreviewLabels'

import CollapsibleSection from './CollapsibleSection'
import EventDayPreviewItem from './EventDayPreviewItem'
import { eventDaysContainerStyle } from './styles'

const DatesSection = ({ isOpen, onToggle, selectedDays, pointsPerTicket }) => (
  <CollapsibleSection isOpen={isOpen} onToggle={onToggle} title={PREVIEW_LABELS.SECTION_DATES} variant="compact">
    <Box css={eventDaysContainerStyle}>
      {selectedDays.map((day, index) => (
        <EventDayPreviewItem
          day={day}
          index={index}
          isLast={index === selectedDays.length - 1}
          key={day.date || index}
          pointsPerTicket={pointsPerTicket}
        />
      ))}
    </Box>
  </CollapsibleSection>
)

export default DatesSection
